export default function IconDashboardGauge({ solid }: { solid?: boolean }) {
	if (solid) {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" id="Dashboard-Gauge-1--Streamline-Flex" height="20" width="20">
				<g id="dashboard-gauge-1--bar-speed-test-loading-dashboard-internet-gauge-progress">
					<path
						id="Union"
						fill="currentColor"
						fillRule="evenodd"
						d="M4.667142857142857 4.667142857142857C3.55 5.785714285714286 2.857142857142857 7.5200000000000005 2.857142857142857 10c0 0.7514285714285714 0.06428571428571428 1.4357142857142855 0.18285714285714286 2.0542857142857143h6.41L13.414285714285715 6.518571428571429a1.0714285714285714 1.0714285714285714 0 0 1 1.7428571428571429 1.2485714285714287l-3.071428571428571 4.285714285714286h4.872857142857143A10.799999999999999 10.799999999999999 0 0 0 17.142857142857142 10c0 -2.48 -0.6928571428571428 -4.214285714285714 -1.8099999999999998 -5.332857142857143C14.214285714285714 3.55 12.48 2.857142857142857 10 2.857142857142857s-4.214285714285714 0.6928571428571428 -5.332857142857143 1.8099999999999998ZM10 20c3.005714285714286 0 5.557142857142858 -0.85 7.352857142857143 -2.6471428571428572C19.15 15.557142857142859 20 13.005714285714285 20 10s-0.85 -5.557142857142858 -2.6471428571428572 -7.352857142857143C15.557142857142859 0.85 13.005714285714285 0 10 0S4.442857142857143 0.85 2.6471428571428572 2.6471428571428572C0.85 4.442857142857143 0 6.994285714285715 0 10s0.85 5.557142857142858 2.6471428571428572 7.352857142857143C4.442857142857143 19.15 6.994285714285715 20 10 20Z"
						clipRule="evenodd"
						strokeWidth="1.4286"
					></path>
				</g>
			</svg>
		);
	}
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M14.0179 7.32144L10 12.9297" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
			<path
				d="M10.0001 18.3705C15.3572 18.3705 18.3706 15.3571 18.3706 10C18.3706 4.64286 15.3572 1.62947 10.0001 1.62947C4.64291 1.62947 1.62952 4.64286 1.62952 10C1.62952 15.3571 4.64291 18.3705 10.0001 18.3705Z"
				stroke="currentColor"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M1.98657 12.9297C2.92995 16.4426 5.71543 18.3705 10.0003 18.3705C14.2852 18.3705 17.0707 16.4426 18.0141 12.9297H1.98657Z"
				stroke="currentColor"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
